var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrow1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 83,
  height: 52,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#006C47",
  strokeWidth: 3,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.901 1.65C58.576 18.383 35.527 32.51 11.748 38.13M19.42 25.542c-3.166 7.184-8.178 12.708-13.861 14.052M24.14 45.975c-5.985-5.02-12.898-7.725-18.581-6.381"
}))));
export default SvgArrow1;